import React from 'react'
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import LoginCodeForm from '../LoginCodeForm/LoginCodeForm';
import Loader from '../../UI/Loader/Loader';
import urls from '../../../urls';
import {useBuyLandForm} from "./hooks";

const BuyLandForm = ({title, activeLandploat}) => {
    const userData = useSelector(state => state.user_data.userData)
    const navigate = useNavigate();

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    const {
        render,
        sendData,
        updateContragent,
        createContragent,
        taskCreate,
        formError,
        formLoader,
        formSuccess,
        sendCode,
        btnActive,
    } = useBuyLandForm({
        initialData: {
            landplot: activeLandploat.id,
            type: activeLandploat.type,
            department: 11, // отдел продаж, ищи если отвалится здесь этот
            category: params.get('type')?.toLowerCase() === 'svo' ? 2 : 1, // Какието разные типы для бэка
            contragent: userData.contragent ?? null, // contragent_id с коллектива а не с бика !!
            preferencial: []
        },
        activeLandploat: activeLandploat
    })


    const nope = () => {
        alert('Очень хитро, но поля заполнить все равно придется)')
    }


    //
    // if (params.get('test') !== 'true')
    //     return <div className="buy-land__form">
    //         <div>
    //             <h2 className='success__title'>Технические работы</h2>
    //             <p className='success__description'>Прямо сейчас форма бронирования становится лучше! Чтобы
    //                 забронировать участок зайдите позже</p>
    //             <button className='success__btn' onClick={() => navigate(urls.cabinet_page.path)}>Вернуться в кабинет
    //             </button>
    //         </div>
    //     </div>

    if (formLoader) return <Loader/>

    return (
        <div className="buy-land__form">
            {formSuccess ?
                <div>
                <h2 className='success__title'>Заявка на бронирование отправлена</h2>
                    <p className='success__description'>Мы получили вашу заявку и передали ее на модерацию.
                        Специалисты БИК проверят данные, которые вы указали. Проверить статус заявки можно в личном
                        кабинете.</p>
                    <p className='success__subtitle'>Спасибо за то, что выбрали БИК!</p>
                    <button className='success__btn' onClick={() => navigate(urls.cabinet_page.path)}>Перейти в
                        личный кабинет
                    </button>
                </div> :
                sendCode ?
                    <>
                        <LoginCodeForm contragentActions={{
                            pass: taskCreate,
                            create: createContragent,
                            update: updateContragent
                        }}/>
                        {formError && <p className='form__error'>{formError}</p>}
                    </> :
                    <>
                        <span className="form__title">{title ?? 'Данные для бронирования'}</span>
                        <p className="form__description">В случае указания заявителем некорректного номера телефона
                            или адреса электронной почты, бронь не будет подтверждена и утратит силу</p>
                        {formError && <p className='form__error'>{formError}</p>}
                        {render}
                        <span className={`form-btn _block mt-16 ${btnActive ? '' : '_disabled'}`}
                              onClick={btnActive ? sendData : nope}>Забронировать</span>
                    </>
            }
        </div>
    )
}

export default BuyLandForm